export type OpenSourceNotice = {
  packageName: string;
  displayName: string;
  version: string;
  license: string;
  licenseUrl: string;
};

/** Exact shipped runtime versions, guarded against package-lock drift by tests. */
export const OPEN_SOURCE_NOTICES: readonly OpenSourceNotice[] = [
  {
    packageName: 'react',
    displayName: 'React',
    version: '19.2.7',
    license: 'MIT',
    licenseUrl: 'https://github.com/facebook/react/blob/v19.2.7/LICENSE',
  },
  {
    packageName: 'react-dom',
    displayName: 'React DOM',
    version: '19.2.7',
    license: 'MIT',
    licenseUrl: 'https://github.com/facebook/react/blob/v19.2.7/LICENSE',
  },
  {
    packageName: 'scheduler',
    displayName: 'React Scheduler',
    version: '0.27.0',
    license: 'MIT',
    licenseUrl: 'https://github.com/facebook/react/blob/v19.2.7/LICENSE',
  },
  {
    packageName: 'three',
    displayName: 'Three.js',
    version: '0.185.1',
    license: 'MIT',
    licenseUrl: 'https://github.com/mrdoob/three.js/blob/r185/LICENSE',
  },
] as const;
